module.exports = __webpack_public_path__ + "img/tratamento_dieta.5ab2380c.jpg";